import React from 'react';

import {CheckboxSkeleton} from 'src/components/skeleton';
import {EMAIL_SETTINGS} from 'src/constants';

import {Group} from '@pb/kit-component-group';


export const SendWelcomeEmailSectionSkeleton = () => (
    <Group direction="v" alignItems="start">
        {Object.keys(EMAIL_SETTINGS).map(emailType => (
            <CheckboxSkeleton key={emailType} labelWidth={168}/>
        ))}
    </Group>
);
